import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm, SortableList } from 'components/common';

import type { GetProductUserCustomAttributesRes } from 'shared-types/responses';

interface Props {
  attributes: GetProductUserCustomAttributesRes['customAttributes'];
  updateData: () => Promise<void>;
  urlState: string;
}

const ProductUserCustomAttributesChangeOrder = ({
  attributes = [],
  updateData,
  urlState
}: Props) => {
  const { dispatch } = useDispatch();

  const { language, messages } = useReduxState();

  const [order, setOrder] = useState(
    attributes.map((attribute) => attribute.id)
  );

  const handleSubmit = async () => {
    await api.post(`/admin/product-user-custom-attributes-order/${urlState}`, {
      newOrder: order
    });
    dispatch(
      actions.addNotice({
        text: messages.commonEditOrderSuccess,
        type: 'success'
      })
    );
    await updateData();
  };

  return (
    <ModalButtonWithForm
      buttonCategory="light"
      buttonDisabled={!attributes}
      buttonIcon="arrows-alt-v"
      buttonSize="header"
      buttonText={messages.commonEditOrder}
      contentStyle={{ padding: 0 }}
      initialValues={{ order: Object.keys(attributes || {}) }}
      modalActionCategory="success"
      modalActionText={messages.commonUpdate}
      modalTitle={messages.commonEditOrder}
      onSubmit={handleSubmit}
    >
      {() => (
        <SortableList
          items={attributes.map((attribute) => ({
            key: attribute.id,
            label: attribute.titleTranslations?.[language] || attribute.title
          }))}
          itemWithBorder={true}
          listId="product-user-custom-attributes-change-order"
          onChange={(keys: number[]) => setOrder(keys)}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default ProductUserCustomAttributesChangeOrder;
